module.exports = __webpack_public_path__ + "media/images/rolando-signature-c66c7d5c22ae7e3bea48a466895e80cdf7b94bf456cdf8dccacd31c87716f9fa.jpeg";